export const siteConfig = {
  name: '漫画网',
  tagline: '在线漫画阅读与推荐平台',
  description:
    '漫画网提供丰富的在线漫画资源，支持按题材分类、按类型找漫画、按标签找书，完结漫画与连载中漫画分门别类，人气分类直接推荐，方便快捷的漫画在线阅读平台。',
  keywords:
    '漫画网,漫画网题材分类,漫画网按类型找漫画,漫画网标签找书,漫画网完结漫画,漫画网连载中漫画,在线漫画,漫画阅读',
  url: 'https://ptqjk48.cn',
  email: 'hello@manga.readdy.site',
  phone: '400-888-0000',
  address: '北京市朝阳区漫阅路 88 号动漫产业园',
};